export const template2PlaceholderData = [
  {
    id: 1,
    name: 'Menu 1',
    categories: [
      {
        id: 1,
        name: 'burgers and sandwisches',
        items: [
          {
            id: 1,
            itemName: 'Truffle Parmesan Fries',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
            outOfStock: true,
          },
          {
            id: 2,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 3,
            itemName: 'Churros',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 4,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 5,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 6,
            itemName: 'Churros',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
        ],
      },
      {
        id: 2,
        name: 'Sandwiches',
        items: [
          {
            id: 7,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 8,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 9,
            itemName: 'Churros',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 10,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 11,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 12,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 13,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
        ],
      },
      {
        id: 3,
        name: 'desserts',
        items: [
          {
            id: 14,
            itemName: 'Churros',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 15,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 16,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 17,
            itemName: 'Churros',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 18,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 19,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 20,
            itemName: 'Churros',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Menu2',
    categories: [
      {
        id: 4,
        name: 'Main',
        items: [
          {
            id: 21,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 22,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 23,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 24,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 25,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 26,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 27,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
        ],
      },
      {
        id: 5,
        name: 'Juices',
        items: [
          {
            id: 28,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 29,
            itemName: 'New York Cheesecake',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 30,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 31,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 32,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 33,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 34,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 35,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 36,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 37,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 38,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 39,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 40,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
          {
            id: 41,
            itemName: 'Iced Latte',
            itemDescription:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
            itemPrice: '10.99',
          },
        ],
      },
    ],
  },
];
